var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 15 15",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .052h14.947v14.857h-14.947z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2c2c2c",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.464 13.77c3.482.014 6.33-2.8 6.34-6.275.01-3.47-2.813-6.292-6.32-6.306-3.477-.012-6.33 2.796-6.34 6.276-.01 3.47 2.811 6.292 6.32 6.305m.016-13.718c4.099 0 7.472 3.288 7.467 7.434-.005 4.138-3.356 7.427-7.479 7.423-4.193-.004-7.476-3.385-7.468-7.444.008-4.095 3.352-7.42 7.48-7.413",
    mask: "url(#a)",
    transform: "translate(0 .039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.448 10.63c-.177-.013-.296-.147-.284-.321.008-.12.015-.24.015-.36v-5.031c0-.053-.005-.107-.012-.16-.017-.13.03-.243.13-.302s.22-.04.33.032c.14.092.286.174.431.258 1.432.82 2.864 1.639 4.294 2.46.071.041.146.092.19.158.099.142.048.326-.113.421-.329.195-.661.383-.993.573l-3.71 2.124c-.04.023-.076.056-.117.078-.052.027-.107.048-.161.07"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBook);
export default __webpack_public_path__ + "static/media/icn_book.c8e4581501b44d561160c1a215de8384.svg";
export { ForwardRef as ReactComponent };